import { AxiosInstance } from "axios";

export const setupInstanceInterceptors = (
instance: AxiosInstance,
  // name?: string,
) => {
  // Example: an instance for `wallet` may need to unwrap `data.result` whereas
  // `user` may return `data.user`. Add custom handlers here.
  instance.interceptors.response.use((res) => {
    // small, non-breaking unwrap helper (do not mutate globally)
    if (res.data && typeof res.data === "object") {
      // Common contract patterns:
      // - { success: true, data: {...} }
      // - { status: 'ok', result: {...} }
      // - raw payload
      // if (name) {
      //   console.warn("setupInstanceInterceptors", name);
      // }
      if ((res.data as any).data)
        return { ...res, data: (res.data as any).data };
      if ((res.data as any).result)
        return { ...res, data: (res.data as any).result };
    }
    return res;
  });
};
